var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"app-spinner",class:{ small: _vm.small }})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }